<template>
  <div class="preview-box">
    <el-dialog title="文件预览" :visible.sync="fileVisible" width="90%" top='10px' @close="fileVisible=false">
      <div style="  display: flex;justify-content: center;">
        <iframe :src="fileSrc" frameborder="0" style="width: 100%; height:80vh "></iframe>
      </div>
    </el-dialog>
    <el-image-viewer v-if="imgVisible" :on-close="()=>{imgVisible=false,imgSrc=''}" :url-list="[imgSrc]" />
  </div>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";

export default {
  components: {
    ElImageViewer
  },
  props: {

  },
  data() {
    return {
      imgVisible: false,
      fileVisible: false,
      fileSrc: '',
      imgSrc:''
    };
  },
  computed: {

  },
  watch: {

  },
  created() {

  },
  mounted() {

  },
  methods: {

  },
};
</script>

<style  lang="less">
.preview-box {
}
</style>
